import { Component, ChangeDetectionStrategy, input, EventEmitter, Output, HostBinding } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { Position } from 'libs/shared/util-common/src/lib/position.util';
import { mapMimeTypeToAttachmentType } from 'shared/domain';
import { KilobytesPipe, UtcToLocalPipe } from 'shared/util-common';

import { Attachment, AttachmentVersion } from '@treetop/shared/model';

import { ButtonDirective } from '../button/button.directive';
import { IconDirective } from '../icon/icon.directive';
import { MenuItemDirective } from '../menu/menu-item.directive';
import { MenuTriggerDirective } from '../menu/menu-trigger.directive';
import { MenuComponent } from '../menu/menu.component';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'tt-attachment-card',
  standalone: true,
  imports: [
    TooltipDirective,
    MatIconModule,
    IconDirective,
    ReactiveFormsModule,
    TranslocoModule,
    FormsModule,
    MenuComponent,
    MenuItemDirective,
    MenuTriggerDirective,
    TooltipDirective,
    ButtonDirective,
    KilobytesPipe,
    UtcToLocalPipe,
  ],
  templateUrl: './attachment-card.component.html',
  styleUrl: './attachment-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentCardComponent {
  public version = input<AttachmentVersion | Attachment | undefined>(undefined);
  public variant = input<'editable' | 'editor' | 'search'>('editable');
  public isReduced = input<boolean>(false);

  @Output() public setActive = new EventEmitter<string>();
  @Output() public downloaded = new EventEmitter<{ versionId: string; originalName: string }>();
  @Output() public previewed = new EventEmitter<string>();
  @Output() public deleted = new EventEmitter<string>();

  @HostBinding('class') public get class() {
    return `tt-attachment-card-component--${this.variant()}`;
  }

  protected Position = Position;
  protected mapMimeTypeToAttachmentType = mapMimeTypeToAttachmentType;
}
